import { Radio } from '@cast/design-system';
import { PolicyAutoscalerMode } from '@cast/types';

import { InputPairContainer } from '../InputPairContainer';
import { PolicyCardForm } from './_components/PolicyCardForm';

import { RffRadioGroup } from '@cast/shared-rff-ui';

type ApplyTypeFieldProps = {
  name: string;
  testId?: string;
  isDefault?: 'IMMEDIATE' | 'DEFERRED' | 'UNKNOWN';
};

export const ApplyTypeField = ({
  name,
  testId,
  isDefault,
}: ApplyTypeFieldProps) => {
  return (
    <RffRadioGroup name={name}>
      <InputPairContainer data-testid={testId}>
        <PolicyCardForm
          control={
            <Radio
              testId="immediate"
              value={PolicyAutoscalerMode.IMMEDIATE}
              size="small"
            />
          }
          label="Immediately"
          isDefault={isDefault === 'IMMEDIATE'}
        />
        <PolicyCardForm
          control={
            <Radio
              testId="deferred"
              value={PolicyAutoscalerMode.DEFERRED}
              size="small"
            />
          }
          label="Deferred"
          isDefault={isDefault === 'DEFERRED'}
        />
      </InputPairContainer>
    </RffRadioGroup>
  );
};
